import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { Message, SpinnerService } from 'shared-components';
import * as _timezones from 'projects/shared-components/src/lib/assets/timezone.json'
import { AdminService } from "../../../services/admin.service";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";

@Component({
    selector: 'app-pss-new-edit',
    templateUrl: './new-edit.component.html'
})
export class PssNewEditComponent implements OnInit {
    private pais;
    public newEditForm: UntypedFormGroup;
    public showError: boolean;
    public showApiError: boolean; // evitar mostrar la clase de error en inputs si falla el getById
    public mensajes = new Array<Message>();
    public disable = false;

    @Input() paisId;
    @Output() refresh = new EventEmitter<boolean>();
    @Output() mensaje = new EventEmitter<string>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _dataProvider: DataProvider,
        private readonly _adminService: AdminService,
        private readonly _sessionContext: SessionContextService
    ) {}

    ngOnInit() {
        this.newEditForm = this._fb.group({
            pais: ['', Validators.required],
            isO3: ['', [Validators.required ,Validators.minLength(3), Validators.maxLength(3)]],
            esProductorModal: [false, Validators.required],
            esDestinoModal: [false, Validators.required],
            timezone: ['', Validators.required],
            desPaisAlias: ['']
        });

        //this.getTimezones();

        if (this.paisId) {
            this.getPais();
        }
    }

    public get timezones() {
        return this._dataProvider.timeZones;
    }

    public get isSmallScreen() {
        return this._sessionContext.isSmallScreen();
    }

    private getPais() {
        this._spinnerService.showSpinner();
        this._adminService.getPais(this.paisId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.pais = resp;
            this.newEditForm.patchValue({
                pais: resp.desPaisDefecto,
                isO3: resp.isO3,
                esProductorModal: resp.esProductor,
                esDestinoModal: resp.esDestino,
                timezone: this.timezones.find(x => x.id === resp.defaultMSTimeZoneID),
                desPaisAlias: resp.desPaisAlias
            });
        }, (error) => {
            this.showApiError = true;
            if (error.status === 420) {
                this.mensajes.push({ class: 'error', message: 'global.error.noAccess' });
            } else {
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
            }
        });
    }

    public close() {
        this.refresh.emit(false);
    }

    public save() {
        this.checkForm();
        if (this.newEditForm.valid && !this.paisId) {
            this.pais = {
                desPaisDefecto: this.newEditForm.get('pais').value ? this.newEditForm.get('pais').value : '' ,
                isO3: this.newEditForm.get('isO3').value ? this.newEditForm.get('isO3').value : '',
                esProductor: this.newEditForm.get('esProductorModal').value ? this.newEditForm.get('esProductorModal').value : false,
                esDestino: this.newEditForm.get('esDestinoModal').value ? this.newEditForm.get('esDestinoModal').value : false,
                defaultMSTimeZoneID: this.newEditForm.get('timezone').value.id ? this.newEditForm.get('timezone').value.id : '',
                desPaisAlias: this.newEditForm.get('desPaisAlias').value ? this.newEditForm.get('desPaisAlias').value : '',
            };
            this._spinnerService.showSpinner();
            this._adminService.createPais(this.pais).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then((resp) => {
                if (resp.id) {
                  this._dataProvider.refreshPaises();
                  this.refresh.emit(true);
                  this.mensaje.emit('global.success.itemCreated');
                } else {
                  this.showError = true;
                  this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                }
            });
        } else if (this.newEditForm.valid && this.paisId) {
            this.pais = {
                id: this.paisId,
                desPaisDefecto: this.newEditForm.get('pais').value ? this.newEditForm.get('pais').value : '' ,
                isO3: this.newEditForm.get('isO3').value ? this.newEditForm.get('isO3').value : '',
                esProductor: this.newEditForm.get('esProductorModal').value ? this.newEditForm.get('esProductorModal').value : false,
                esDestino: this.newEditForm.get('esDestinoModal').value ? this.newEditForm.get('esDestinoModal').value : false,
                defaultMSTimeZoneID: this.newEditForm.get('timezone').value.id ? this.newEditForm.get('timezone').value.id : '',
                desPaisAlias: this.newEditForm.get('desPaisAlias').value ? this.newEditForm.get('desPaisAlias').value : '',
            };
            this._spinnerService.showSpinner();
            this._adminService.updatePais(this.pais).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then(
                (resp) => {
                    this._dataProvider.refreshPaises();
                    this.refresh.emit(true);
                    this.mensaje.emit('global.success.itemUpdated');
                },
                (error) => {
                    this.showError = true;
                    this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                }
            );
        }
    }

    private checkForm() {
        this.showError = this.newEditForm.invalid;
        if (this.newEditForm.get('isO3').hasError('minlength') && this.showError) {
            this.mensajes.push({ class: 'error', message: 'El campo isO3 no debe tener menos de 3 carácteres'});
        } 
        
        if (this.newEditForm.get('isO3').hasError('maxlength') && this.showError) {
            this.mensajes.push({ class: 'error', message: 'El campo isO3 no debe superar los 3 carácteres'});
        }
        
        if ((this.newEditForm.get('pais').hasError('required') || this.newEditForm.get('isO3').hasError('required') ||
            this.newEditForm.get('esProductorModal').hasError('required') || this.newEditForm.get('esDestinoModal').hasError('required') ||
            this.newEditForm.get('timezone').hasError('required')) && this.showError) {
                this.mensajes.push({ class: 'error', message: 'global.error.required'});
        }
    }
}
